import { Form } from '@mage-ui/components';
import { z } from 'zod';

export const rules = ({ st }) =>
	z
		.object({
			name: Form.InputText.rules.required(
				st('validation.required', { attribute: '' }),
			),
			surnames: Form.InputText.rules.required(
				st('validation.required', { attribute: '' }),
			),
			email: Form.InputText.rules
				.required(st('validation.required', { attribute: '' }))
				.email({ message: st('validation.email', { attribute: '' }) }),

			email_confirmation: Form.InputText.rules
				.required(st('validation.required', { attribute: '' }))
				.email({ message: st('validation.email', { attribute: '' }) }),
		})
		.superRefine((data, ctx) => {
			if (data.email !== data.email_confirmation) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: st('validation.confirmed', { attribute: '' }),
					path: ['email_confirmation'],
				});
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: st('validation.confirmed', { attribute: '' }),
					path: ['email'],
				});
			}
		});
